import { useState } from 'react'
import { withTranslation } from 'react-i18next'

import ProductModal from '@/features/Menu/components/ProductModal'
import RemoveProductModal from '@/features/Menu/components/RemoveProductModal'
import { CURRENCY } from '@/lib/consts'
import Button from '@/ui/Button'

import useCheckout from '../../hooks/useCheckout'
import CartItem from '../CartItem'
import CheckoutStep from '../CheckoutStep'
import { CartSummary, CartSummaryTitle, CartSummaryValue, CartWrapper } from './Cart.styles'

const Cart = ({ t }) => {
  const { cart, cartTotal, setCurrentStep } = useCheckout()
  const [activeProduct, setActiveProduct] = useState(null)
  const [productToRemove, setProductToRemove] = useState(null)

  return (
    <CheckoutStep
      title={t('orderSummary')}
      action={
        <Button size="xl" onClick={() => setCurrentStep('PAYMENT')}>
          {t('makeOrder')}
        </Button>
      }
    >
      <CartWrapper>
        {cart.map((item, index) => (
          <CartItem key={index} {...item} onEdit={() => setActiveProduct(item)} onRemove={() => setProductToRemove(item)} />
        ))}
      </CartWrapper>
      <CartSummary>
        <CartSummaryTitle>{t('yourOrder')}</CartSummaryTitle>
        <CartSummaryValue>
          {cartTotal.toFixed(2)} {CURRENCY}
        </CartSummaryValue>
      </CartSummary>

      {activeProduct && (
        <ProductModal mode="EDIT" product={activeProduct} title={activeProduct.name} onClose={() => setActiveProduct(null)}></ProductModal>
      )}

      {productToRemove && <RemoveProductModal product={productToRemove} onClose={() => setProductToRemove(null)}></RemoveProductModal>}
    </CheckoutStep>
  )
}

export default withTranslation()(Cart)
